<mat-form-field class="select" appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <mat-select (selectionChange)="onNumberOfTicketsChange($event)" color="primary">
    <mat-option *ngFor="let option of options" [value]="option.id">
      {{ option.text }}
    </mat-option>
  </mat-select>
</mat-form-field>
